import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { BuildingTypeAnswerType, DefaultContinueHandlerType, RenderViewReturnType } from '../types';
import type { RenderSimpleButtonGroupPropsType } from '../SimpleButtonGroup';
import { BuildingTypeButtonGroup } from '../../../React/features/Chat/features/BuildingTypeButtonGroup';

export const COMPONENT_IDENTIFIER = 'building-type-button-group';

export type RenderBuildingTypeButtonGroupPropsType = Overwrite<RenderSimpleButtonGroupPropsType, {
  answers: Required<BuildingTypeAnswerType>[];
}>

export const renderBuildingTypeButtonGroup = async (props: RenderBuildingTypeButtonGroupPropsType): RenderViewReturnType => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(`chat-${COMPONENT_IDENTIFIER}-container`);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: DefaultContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<BuildingTypeButtonGroup {...props} continueHandler={continueHandler} />);
  });
};
